import React from "react";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useState } from "react";
import { useParams } from "react-router";
import { useEffect } from "react";
import LoadingPage from "../../../Components/layouts/loading";
import Footer from "../../../Components/Footer/footer";
import { FcDataConfiguration } from "react-icons/fc";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsPatchPlus } from "react-icons/bs";

function ViewMaterial() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/newMaterialModel/getMaterialModelByID/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while Material Planning Details!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcDataConfiguration
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  View Material Details {`(${data?.bay} * ${data?.span})`}
                </h2>
                <h4 className="text-muted">{data?.systemType}</h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/material-planning"}>
                    <button className="btn btn-primary mb-3 mb-lg-0 mb-md-0 mb-xl-0">
                      <BsPatchPlus className="me-2 fs-2" />VIEW MATERIAL PLAN LIST
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="col-12 py-2">
                  <div className="card">
                    <div className="table-responsive">
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            <th>Sr</th>
                            <th>item Name</th>
                            <th></th>
                            <th>material Type</th>
                            <th>diameter (mm)</th>
                            <th>length (mm)</th>
                            <th>quantity</th>

                            <th>weight</th>
                            <th>rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.newMaterialPlaning &&
                            Object.keys(data?.newMaterialPlaning).map(
                              (key, index) => {
                                const item = data?.newMaterialPlaning[key];

                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td colSpan={2}>{item.itemName}</td>
                                    <td>
                                      {item.materialType
                                        ? item.materialType
                                        : "---"}
                                    </td>
                                    <td>{item.diameterInMM}</td>
                                    <td>{item.lengthInMeters}</td>
                                    <td>
                                      {item.quantity ? item.quantity : "---"}{" "}
                                      {item.quantity && item.quantityUnit
                                        ? item.quantityUnit
                                        : ""}
                                    </td>

                                    <td>
                                      {item.weight ? item.weight : "---"}{" "}
                                      {item.weight && item.weightUnit
                                        ? item.weightUnit
                                        : ""}
                                    </td>

                                    <td>{item.rate ? item.rate : "---"}</td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                  <h3 className="ms-3">Soft Material:</h3>
                  <hr />
                  <div className="card">
                    <div className="table-responsive">
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            <th>Sr</th>
                            <th>item Name</th>
                            <th></th>

                            <th>width (m)</th>
                            <th>length (mm)</th>
                            <th>quantity</th>
                            <th>perQuantityArea</th>
                            <th>totalArea</th>
                            <th>rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.newSoftMaterial &&
                            Object.keys(data?.newSoftMaterial).map(
                              (key, index) => {
                                const item = data?.newSoftMaterial[key];
                                if (
                                  key !== "pollyhouseDesign1" &&
                                  key !== "pollyhouseDesign2"
                                ) {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td colSpan={2}>{item.itemName}</td>
                                      <td>{item.width}</td>
                                      <td>{item.length}</td>
                                      <td>
                                        {item.quantity ? item.quantity : "---"}{" "}
                                        {item.quantity && item.quantityUnit
                                          ? item.quantityUnit
                                          : ""}
                                      </td>

                                      <td>
                                        {item.perQuantityArea
                                          ? item.perQuantityArea
                                          : "---"}
                                      </td>
                                      <td>
                                        {item.totalArea
                                          ? item.totalArea
                                          : "---"}
                                      </td>
                                      <td>{item.rate ? item.rate : "---"}</td>
                                    </tr>
                                  );
                                } else {
                                  return;
                                }
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <div className="mb-3 row mx-2">
                      <label className="w-25 form-label col-3 ">
                        Pollyhouse Design (Top View):
                      </label>

                      <div className="w-100 col">
                        {data?.newSoftMaterial?.pollyhouseDesign1 ? (
                          <LazyImageComponent
                            width="70%"
                            src={data?.newSoftMaterial?.pollyhouseDesign1}
                            alt="Pollyhouse Design (Top View)"
                          />
                        ) : (
                          "Not Available".toUpperCase()
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row mx-2">
                      <label className="w-25 form-label col-3 ">
                        Pollyhouse Design (Internal):
                      </label>
                      <div className="w-100 col">
                        {data?.newSoftMaterial?.pollyhouseDesign2 ? (
                          <LazyImageComponent
                            width="70%"
                            src={data?.newSoftMaterial?.pollyhouseDesign2}
                            alt="Pollyhouse Design (Internal)"
                          />
                        ) : (
                          "Not Available".toUpperCase()
                        )}
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h3 className="ms-3">To Be Produce:</h3>
                  <hr />
                  <div className="card">
                    <div className="table-responsive">
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            <th>Sr</th>
                            <th>Size</th>
                            <th></th>
                            <th>3 mm</th>
                            <th>2.9 mm</th>
                            <th>2.6 mm</th>
                            <th>2 mm</th>
                            <th>1.8 mm</th>
                            <th>1.6 mm</th>
                          </tr>
                        </thead>

                        <tbody>
                          {data?.newToBeProduced &&
                            Object.keys(data?.newToBeProduced).map(
                              (key, index) => {
                                const item = data?.newToBeProduced[key];

                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td colSpan={2}>{item.itemName}</td>
                                    <td>{item.s3mm}</td>
                                    <td>{item.s2p9mm}</td>
                                    <td>{item.s2p6mm}</td>
                                    <td>{item.s2mm}</td>
                                    <td>{item.s1p8mm}</td>
                                    <td>{item.s1p6mm}</td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Edit Material Planning"
                      href={`/material-planning/edit/${id}`}
                    />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default ViewMaterial;
